import React,{useState} from "react";
import Header from "../Header";
import Head from "../Header/head.js";
import { Link } from "react-router-dom";
import { Discuss } from "react-loader-spinner";
import { useSelector,useDispatch } from "react-redux";
import { checkSubscription } from "../../redux/actions/subscription_action.js";
import { getRemainingDebateAction } from "../../redux/actions/check_remaining_debate_action.js";
function Event(){
    const auth = useSelector((state)=>state.jwtAuthreducer);

   const {status} = useSelector((state)=>state.subscriptionReducer)
   const dispatch = useDispatch();
   
   if(status === null){
    dispatch(checkSubscription());
   }
   console.log(status,"from event")
    return (
        <>
        <Head/>
        <div className="container">
            <div className="row" style={{marginTop:"200px"}}>
                <div className="col-sm-6">
                {/* <Link to={status?"/avatar":"/subscription"} state={{ joined_as: "mediator" }}> */}
                <Link to="/avatar"state={{ joined_as: "mediator" }}>
                <div  style={{cursor:"pointer"}} className="card d-block h-100 shadow p-3 mb-5 bg-white rounded" >
                <div className="pt-3 h-75p align-items-center d-flex justify-content-center">
                    <img style={{width: "100px", maxHeight : "100%"}} className ="img-fluid w-xs-200p" src={process.env.PUBLIC_URL + 'img/debate.png' } href="" alt="valkyrie ship image"/>
                </div>
                <div className="container" style={{textAlign: "center"}}>
                    <h3>Create Debate</h3>
                </div>              
                </div>
                </Link>

                </div>

                <div className="col-sm-6">
                    {/* <Link to="/avatar" state={{ type: "participants" }}> */}
                    <Link to="/join" state={{ type: "participants" }}>
                    <div style={{cursor:"pointer"}} className="card d-block h-100 shadow p-3 mb-5 bg-white rounded pointer">
                        <div className="pt-3 h-75p align-items-center d-flex justify-content-center">
                            <img style={{width:"100px" ,maxHeight : "100%"}} className="img-fluid w-xs-200p" src={process.env.PUBLIC_URL + 'img/politicians.png' } href="" alt="valkyrie ship image"/>
                        </div>
                        <div className="container" style={{textAlign: "center"}}>
                            <h3>Join Debate</h3>
                        </div>
               
                    </div>
                    </Link>

                </div>

            </div>

        </div>
        </>

    );
}

export default Event;